
import { setFlashMessage } from "../../../helpers"
import { API_ROUTES } from "../../../constants/apiRoutes"
import apiClient from "../../../services/api/apiClient"
import { useRef, useState } from "react"

import HousePilotModalMetrics from "./Modal_Metrics";


export class DeviceBoxManagement {

    showModalEditCE() {
        const modal = document.getElementById('editCeModal')
        if (modal) {
            modal.classList.add('show')
            modal.classList.add('d-block')
        }
    }

    hideModalEditCE() {
        const modal = document.getElementById('editCeModal')
        if (modal) {
            modal.classList.remove('d-block')
            modal.classList.remove('show')
        }
    }

    getProgPumpTimesFromDetails() {
        return {
            main: {
                start: {
                    hours: this._progPumpDetails?.main?.start?.split(':')[0],
                    minutes: this._progPumpDetails?.main?.start?.split(':')[1]
                },
                end: {
                    hours: this._progPumpDetails?.main?.end?.split(':')[0],
                    minutes: this._progPumpDetails?.main?.end?.split(':')[1]
                }
            },
            secondary: {
                start: {
                    hours: this._progPumpDetails?.secondary?.start?.split(':')[0],
                    minutes: this._progPumpDetails?.secondary?.start?.split(':')[1]
                },
                end: {
                    hours: this._progPumpDetails?.secondary?.end?.split(':')[0],
                    minutes: this._progPumpDetails?.secondary?.end?.split(':')[1]
                }
            }
        }
    }

    isPumpProgSecondaryActive() {
        return ((this._progPumpDetails?.secondary.start !== this._progPumpDetails?.secondary.end) || this._enableProgPumpSecondary === true)
    }

    getChangePayload() {
        return {
            main: {
                startHour: this._progPumpTimes.main.start.hours,
                startMinutes: this._progPumpTimes.main.start.minutes,
                endHour: this._progPumpTimes.main.end.hours,
                endMinutes: this._progPumpTimes.main.end.minutes
            },
            secondary: {
                enabled: this._enableProgPumpSecondary === true,
                startHour: this._progPumpTimes.secondary.start.hours,
                startMinutes: this._progPumpTimes.secondary.start.minutes,
                endHour: this._progPumpTimes.secondary.end.hours,
                endMinutes: this._progPumpTimes.secondary.end.minutes
            },
            boostMode: this._isBoostActive === true,
            absenceMode: this._isAbsenceMode === true,
            mode24h: false

        }
    }

    validateChanges(data = null) {
        if (!data) {
            data = this.getChangePayload()
        }
        const payload = {
            deviceName: 'O_CE',
            operation: 'SET_CE_PROG',
            value: data
        }


        apiClient.post(API_ROUTES.DEVICES_CHANGE_STATE, payload).then(() => {
            setFlashMessage('success', 'Paramétrage du CE changée avec succès.')
        }).catch(() => {
            setFlashMessage('error', 'Erreur lors de la mise à jour de la programmation du CE.')
        }).finally(() => {
            this.hideModalEditCE()
        })
    }

    toggleCeEvening() {
        const data = this.getChangePayload()
        if (data.secondary.startHour !== data.secondary.endHour) {
            data.secondary.enabled = false
            data.secondary.startHour = '20'
            data.secondary.startMinutes = '00'
            data.secondary.endHour = '20'
            data.secondary.endMinutes = '00'
        } else {
            data.secondary.startHour = '20'
            data.secondary.startMinutes = '00'
            data.secondary.endHour = '23'
            data.secondary.endMinutes = '45'
            data.secondary.enabled = true
        }
        this.validateChanges(data)
    }
}

const listHours = Array(24).fill(0).map((val, index) => {
    if (index < 10) {
        index = "0" + index
    }
    return <option key={index} value={index}>{index}</option>
})
const listMinutes = Array(4).fill(0).map((val, index) => {
    let value = index === 0 ? 0 : index * 15
    if (value < 10) {
        value = "0" + value
    }
    return <option key={index} value={value} >{value}</option>
})



export default function HousePilotDeviceBoxCE({ deviceName, deviceLabel, currentTemp, targetTemp, isActive, consoTotal, pumpHeat, progPump, progPumpDetails, _isBoostActive, _isAbsenceMode }) {

    const [canShowModalMetrics, setCanShowModalMetrics] = useState(false)
    const [isCollapsed, setIsCollapsed] = useState(true)
    const [enableProgPumpSecondary, setEnableProgPumpSecondary] = useState(false)
    const [isBoostActive, setIsBoostActive] = useState(_isBoostActive)
    const [isAbsenceMode, setIsAbsenceMode] = useState(_isAbsenceMode)

    const manager = new DeviceBoxManagement()
    manager._progPumpDetails = progPumpDetails
    manager._enableProgPumpSecondary = enableProgPumpSecondary
    manager._isBoostActive = isBoostActive
    manager._isAbsenceMode = isAbsenceMode

    consoTotal = consoTotal.toFixed(1)

    //    const [progPumpTimes, setProgPumpTimes] = useState(manager.getProgPumpTimesFromDetails())
    manager._progPumpTimes = manager.getProgPumpTimesFromDetails()

    function onModalCloseHandler() {
        setCanShowModalMetrics(false)
    }

    let pumpMode = '24h'
    if (progPump === 'pacProg_elecProg') {
        pumpMode = progPumpDetails.main.start + ' à ' + progPumpDetails.main.end
        pumpMode = pumpMode.replaceAll(':', 'h')
        if (progPumpDetails.secondary.start !== progPumpDetails.secondary.end) {
            pumpMode += "<br/> et de " + progPumpDetails.secondary.start + ' à ' + progPumpDetails.secondary.end
        }
        pumpMode = pumpMode.replaceAll(':', 'h')
    }

    return (
        <>
            <div className={"m-1 col-8 col-sm-5 col-md-6 col-lg-3 deviceBox " + (isActive ? 'active' : '')}>
                <i className="fa fa-info-circle float-left cursor-pointer" data-toggle="modal" onClick={() => setCanShowModalMetrics(true)}></i>
                <i className={"fa " + (isCollapsed ? 'fa-chevron-down' : 'fa-chevron-up') + " float-right cursor-pointer"} onClick={() => setIsCollapsed(!isCollapsed)}></i>
                <h6>{deviceLabel} <i className={"fa " + (isActive ? 'fa-fire' : 'fa-moon-o')}  ></i>
                    <strong><i className="fa fa-edit float-right cursor-pointer" data-toggle="modal" data-target="#editCeModal" onClick={() => manager.showModalEditCE()}></i></strong> </h6>
                <i className="fa fa-thermometer-quarter-o"></i> <strong>{currentTemp} °C / {targetTemp} °C</strong><br />
                <i className="fa fa-bolt"></i> <strong>{consoTotal} Kw/h</strong>
                &nbsp;&nbsp;<i className="fa fa-superpowers"></i><strong>{pumpHeat} w/h </strong><br />
                {!isCollapsed && (
                    <>

                        <strong><i className="fa fa-clock-o"></i> PAC :  <span dangerouslySetInnerHTML={{ __html: pumpMode }}></span></strong><br />
                        <strong><i className="fa fa-sun-o"></i> Boost : {isBoostActive ? 'Oui' : 'Non'}</strong><br />
                        <strong><i className="fa fa-moon-o"></i> Mode absence : {isAbsenceMode === true ? 'Oui' : 'Non'}</strong><br />
                        <button className="btn btn-warning" onClick={() => manager.toggleCeEvening()}>Basculer plage chauffe soir (20h-0h)</button>
                        <br />
                    </>
                )}
            </div>

            <HousePilotModalMetrics deviceLabel={deviceLabel} deviceName={deviceName} showModal={canShowModalMetrics} onModalClose={onModalCloseHandler} />

            <div className="modal fade" id="editCeModal" role="dialog" aria-hidden="true" style={{ zIndex: 2 }}>
                <div className="modal-dialog modal-lg" role="document">
                    <div className="modal-content">
                        <div className="modal-header d-block text-center">
                            <h4>Edition paramètres CE</h4>
                        </div>
                        <div className="modal-body">
                            <h6 className="text-center">Plages de chauffe principale</h6>
                            De
                            <select className="form-control w-25 d-inline-block" id="ce_prog_main_start_hour" defaultValue={manager._progPumpTimes.main.start.hours} onChange={(e) => { manager._progPumpTimes.main.start.hours = e.target.value }}>
                                {listHours}
                            </select>
                            H
                            <select className="form-control w-25 d-inline-block" id="ce_prog_main_start_minutes" defaultValue={manager._progPumpTimes.main.start.minutes} onChange={(e) => { manager._progPumpTimes.main.start.minutes = e.target.value }}>
                                {listMinutes}
                            </select>
                            <br /><br />
                            à
                            <select className="form-control w-25 d-inline-block" id="ce_prog_main_end_hour" defaultValue={manager._progPumpTimes.main.end.hours} onChange={(e) => { manager._progPumpTimes.main.end.hours = e.target.value }}>
                                {listHours}
                            </select>
                            H
                            <select className="form-control w-25 d-inline-block" id="ce_prog_main_end_minutes" defaultValue={manager._progPumpTimes.main.end.minutes} onChange={(e) => { manager._progPumpTimes.main.end.minutes = e.target.value }}>
                                {listMinutes}
                            </select>

                            <br /><br />
                            <label className="checkbox-inline">
                                <input type="checkbox" id="ce_mode_24h" /> Mode 24/24 h
                            </label>

                            <br />
                            <hr />
                            <h6 className="text-center">Plage de chauffe secondaire</h6>
                            <label className="checkbox-inline">
                                <input type="checkbox" id="ce_prog_secondary_enabled" onClick={() => { setEnableProgPumpSecondary(!enableProgPumpSecondary) }} /> Activer
                                plage chauffe secondaire
                            </label>

                            <div className={manager.isPumpProgSecondaryActive() ? '' : 'd-none'} id="ce_prog_secondary_part">
                                De
                                <select className="form-control w-25 d-inline-block" id="ce_prog_secondary_start_hour" defaultValue={manager._progPumpTimes?.secondary.start.hours} onChange={(e) => { manager._progPumpTimes.secondary.start.hours = e.target.value }}>
                                    {listHours}
                                </select>
                                H
                                <select className="form-control w-25 d-inline-block" id="ce_prog_secondary_start_minutes" defaultValue={manager._progPumpTimes?.secondary.start.minutes} onChange={(e) => { manager._progPumpTimes.secondary.start.minutes = e.target.value }}>
                                    {listMinutes}
                                </select>
                                <br /><br />
                                à
                                <select className="form-control w-25 d-inline-block" id="ce_prog_secondary_end_hour" defaultValue={manager._progPumpTimes?.secondary.end.hours} onChange={(e) => { manager._progPumpTimes.secondary.end.hours = e.target.value }}>
                                    {listHours}
                                </select>
                                H
                                <select className="form-control w-25 d-inline-block" id="ce_prog_secondary_end_minutes" defaultValue={manager._progPumpTimes?.secondary.end.minutes} onChange={(e) => { manager._progPumpTimes.secondary.end.minutes = e.target.value }}>
                                    {listMinutes}
                                </select>
                            </div>

                            <hr />
                            <div className="text-center">
                                <h6>Boost mode</h6>
                                <button className={"btn btn-toggle " + (isBoostActive ? 'enabled' : '')} id="boostModeEnabled" onClick={() => { setIsBoostActive(!isBoostActive) }}>
                                    <span className="btn-toggle-content"></span>
                                </button>
                                <h6>Mode absence</h6>
                                <button className={"btn btn-toggle " + (isAbsenceMode ? 'enabled' : '')} id="absenceModeEnabled" onClick={() => { setIsAbsenceMode(!isAbsenceMode) }}>
                                    <span className="btn-toggle-content"></span>
                                </button>
                            </div>


                        </div>
                        <div className="modal-footer text-center mx-auto">
                            <button type="button" className="btn btn-danger" data-dismiss="modal" onClick={() => manager.hideModalEditCE()}>Annuler</button>
                            <a href="#" onClick={() => manager.validateChanges()}>
                                <button type="button" className="btn btn-primary">Valider</button>
                            </a>
                        </div>
                    </div>
                </div>
            </div >
        </>
    )
}
